export const eAWebsiteFormsApiHandler = {
  method: "POST",
  path: () => `forms`
};